<template>
    <b-container fluid>
        <header-buttons
            :buttons="headerButtons"
            @onAddContact="addContact"
        >
        </header-buttons>
        <b-row class="align-items-center justify-content-end">
            <b-col cols="12" md="4" class="mb-3">
                <inter-select
                    v-model="queryAge"
                    :option-selected="queryAge"
                    :options="[
                                { name: 'Tutti', value: 'all'},
                                { name: 'Solo Atleti', value: 'junior'},
                                { name: 'Solo Accompagnatori', value: 'senior'}
                                ]"
                >
                </inter-select>
            </b-col>
            <b-col cols="12" md="4" class="mb-3">
                <inter-input
                    v-model="query"
                    type="text"
                    icon="filter">
                </inter-input>
            </b-col>
        </b-row>
        <b-row v-if="contactList.length">
            <b-col cols="12" v-for="(item, index) in contactList" v-bind:key="index">
                <h3 class="text-uppercase text-primary">{{item.letter}}</h3>
                <hr class="mt-1">
                <b-container fluid>
                    <b-row>
                        <b-col cols="12" md="4" class="mb-3" v-for="(contact, index) in item.contacts"
                               v-bind:key="index">
                            <society-contact-container
                                @onClick="editContact"
                                :contact="contact"
                                :confirmAction="false"
                            >
                            </society-contact-container>
                        </b-col>
                    </b-row>
                </b-container>
            </b-col>
        </b-row>
        <inter-modal
            title-icon="flaticon-group"
            :buttonPrimary="buttonPrimary"
            :title="titleModal"
            :visible="showModal"
            @onPrimaryClick="saveContact">
            <society-contact-form :contact="contact" ref="societyContactForm"></society-contact-form>
        </inter-modal>
    </b-container>
</template>

<script>

    import HeaderButtons from "../../../components/headers-buttons/HeaderButtons";
    import InterInput from "../../../components/form/inter-input/InterInput";
    import InterSelect from "../../../components/form/inter-select/InterSelect";
    import InterModal from "../../../components/modal/InterModal";
    import Contact from '@/models/Contact';
    import SocietyContactForm from "../forms/SocietyContactForm";
    import {mapActions} from 'vuex'
    import _ from 'lodash';
    import Utils from '@/utils';
    import SocietyContactContainer from "../components/contact-container/SocietyContactContainer";
    import TicketService from "@/services/ticket-service";

    export default {
        name: "SocietyContactsListView",
        components: {
            SocietyContactContainer,
            SocietyContactForm, InterModal, InterSelect, InterInput, HeaderButtons
        },
        data() {
            return {
                headerButtons: [
                    {
                        label: 'Nuovo Contatto',
                        onClick: 'onAddContact',
                    }
                ],
                query: '',
                orderByField: null,
                orderByFieldDirection: null,
                selectOrderContactsOptions: [],
                buttonPrimary: {
                    label: 'Salva',
                    confirm: true
                },
                showModal: false,
                titleModal: 'Modifica Contatto',
                contact: Object.assign({}, Contact),
                contacts: [],
                queryAge: 'all'
            }
        },
        mounted() {
            this.$root.$on('bv::modal::hide', () => {
                this.showModal = false;
            });
            this.contacts = [];
            this.societyContactGet()
                .then((resp) => {
                    this.contacts = resp;
                })
                .catch(() => {
                    this.$bvToast.toast('Problemi nel caricamento dei contatti', {
                        title: 'Alert',
                        variant: 'warning'
                    });
                })

            // if(!this.getNazioni.length) {
            this.commonGetNazioni()
                .then()
                .catch();
            // }

            // if(!this.getProvincie.length) {
            this.commonGetProvincie()
                .then()
                .catch();
            // }


        },
        computed: {
            contactList: function () {
                let items = _(this.contactFiltered)
                    .groupBy(o => o.surname[0].toUpperCase())
                    .map((contacts, letter) => ({letter, contacts}))
                    .value();
                return _.orderBy(items, 'letter');
            },
            contactFiltered: function () {
                let filtered = [];
                switch(this.queryAge) {
                    case 'junior':
                        filtered = TicketService.filterJuniors(this.contacts);
                        break;
                    case 'senior':
                        filtered = TicketService.filterSeniors(this.contacts);
                        break;
                    case 'all': filtered = this.contacts;
                        break;
                }

                if (this.query.length < 3) {
                    return filtered;
                }
                const query = this.query.toLowerCase();
                return _.filter(filtered, function (item) {
                    return item.surname.toLowerCase().includes(query)
                        || item.name.toLowerCase().includes(query)
                        || item.email.toLowerCase().includes(query)
                });
            }
        },
        methods: {

            ...mapActions({
                societyContactStore: 'societyContactStore',
                societyContactGet: 'societyContactGet',
                commonGetProvincie: 'commonGetProvincie',
                commonGetNazioni: 'commonGetNazioni'
            }),

            editContact: function (contact) {
                this.titleModal = 'Modifica ' + contact.surname + ' ' + contact.name;
                this.contact = Object.assign({}, contact);
                this.contact.birth_date = Utils.setDateFormatITA(this.contact.birth_date);
                this.showModal = true;
            },

            saveContact: function () {
                if (this.$refs.societyContactForm.validate()) {
                    if(this.contact.birth_nation_id !== 168) {
                        this.contact.birth_place_id = null;
                        this.contact.birth_prov_id = null;
                    }

                    if(this.contact.nation_id !== 168) {
                        this.contact.place_id = null;
                        this.contact.prov_id = null;
                    }

                    this.societyContactStore(this.contact)
                        .then((data) => {
                            this.$bvToast.toast('Contatto salvato', {
                                title: 'Success',
                                variant: 'success'
                            });
                            this.showModal = false;
                            if(this.contact.id) {
                                this.contacts = _.map(this.contacts, (item) => {
                                    return data.id === item.id ? data : item;
                                })
                            } else {
                                this.contacts.push(data);
                            }
                        })
                        .catch(() => {
                            this.$bvToast.toast('Contatto non salvato', {
                                title: 'Alert',
                                variant: 'warning'
                            });
                            this.showModal = false;
                        });
                }

            },

            addContact: function () {
                this.titleModal = 'Nuovo Contatto';
                this.contact = Object.assign({}, Contact);
                this.showModal = true;
            }
        }
    }
</script>

<style scoped>

</style>
